type ParsedContractualTerm = {
	termName: string;
	version: string;
};

export const parseContractualTermUrl = (url: string): ParsedContractualTerm => {
	const [documentName = ''] = url.split('/').filter(Boolean).slice(-1);
	const [versionSuffix = '', version = ''] = documentName.match(/_(v\d+)$/i) ?? [];

	return {
		termName: versionSuffix ? documentName.slice(0, -versionSuffix.length) : documentName,
		version,
	};
};
